import { createFileRoute } from '@tanstack/react-router';
import GameDetailsPage from '../../../pages/admin/GameDetails';
import { gameQueryOptions, playersQueryOptions } from '../../../lib/queryOptions';

export const Route = createFileRoute('/admin/games/$gameId')({
  loader: ({ context: { queryClient }, params: { gameId } }) =>
    Promise.all([
      queryClient.ensureQueryData(gameQueryOptions(gameId)),
      queryClient.ensureQueryData(playersQueryOptions()),
    ]),
  component: GameDetailsPage,
});
